
// Material ui
import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    Switch,
    TextField,
    Typography, Tooltip 
} from '@mui/material';
import React, { useState } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SendIcon from "@mui/icons-material/Send";
import { useTheme } from '@mui/material/styles';
import { keyframes, styled } from '@mui/system';
import LOGO from "./image/17Talk.png";
import './App.css';
// import DescriptionIcon from '@mui/icons-material/Description';

export const ResponseFormatToggle = ({ isAudioResponse, setIsAudioResponse }) => {

    const handleToggleChange = (event) => {
        setIsAudioResponse(event.target.checked);
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 0 }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={isAudioResponse}
                        onChange={handleToggleChange}
                        color="primary"
                    />
                }
                // label="Audio response"
                // label="音"
                label=""
            />
        </Box>
    );
}


export const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
  `;


export const ThinkingBubbleStyled = styled(MoreHorizIcon)`
    animation: ${pulse} 1.2s ease-in-out infinite;
    margin-bottom: -5px;
  `;


export const ThinkingBubble = () => {
    const theme = useTheme();
    return <ThinkingBubbleStyled theme={theme} sx={{ marginBottom: '-5px' }} />;
};

const languageButtonCodes = {
    "English": "EN",
    "Chinese": "CN",
    "Vietnamese": "VN"
}
export const MessageInput = ({ refMessages, setRefMessages, isRecording, setIsRecording, thinking, setThinking, message, setMessage, setMessages, isAudioResponse, handleSendMessage, learnLanguage, nativeLanguage }) => {

    const handleInputChange = (event) => {
        setMessage(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            if (isRecording || thinking) return;
            handleSendMessage("1");
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.shiftKey) {
            event.preventDefault();
            setMessage(event.target.value + '\n');
        }
    };

    // Chatbot box
    return (
        <>
            <div className="clock">
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={10}>
                            <TextField
                                id="inputBox"
                                multiline
                                rows={3}
                                onKeyDown={handleKeyDown}
                                variant="outlined"
                                fullWidth
                                label="Type your message"
                                value={message}
                                inputProps={{ maxLength: 300 }}
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                            />
                        </Grid>
                        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <IconButton
                                color="primary"
                                onClick={() => handleSendMessage("1")}
                                disabled={message.trim() === "" || thinking || isRecording}
                                style={{ marginLeft: -50, marginTop: 25 }}
                            >
                                {<SendIcon />}
                            </IconButton>
                            
                        </Grid>
                    </Grid>
                </Box>
            </div>

            <Box sx={{ display: "flex", alignItems: "center", marginTop: -1 }}>
            <Tooltip title={
                nativeLanguage === "English" ? `Translate to ${nativeLanguage}` : 
                nativeLanguage === "Vietnamese" ? `Dịch sang ${nativeLanguage}` : 
                nativeLanguage === "Chinese" ? `翻译成 ${nativeLanguage}` : ''}>
                <Button
                    style={{ marginLeft: -12 }}
                    color="primary"
                    onClick={() => handleSendMessage("2", "translateToNative")}
                    disabled={message.trim() === "" || thinking || isRecording}
                >
                    {`>>${languageButtonCodes[nativeLanguage]}`}
                </Button>
                </Tooltip>
                <Tooltip title={
                nativeLanguage === "English" ? `Translate to ${learnLanguage}` : 
                nativeLanguage === "Vietnamese" ? `Dịch sang ${learnLanguage}` : 
                nativeLanguage === "Chinese" ? `翻译成 ${learnLanguage}` : ''}>
                    <Button
                        style={{ marginLeft: -12 }}
                        color="primary"
                        onClick={() => handleSendMessage("2", "translateToLearn")}
                        disabled={message.trim() === "" || thinking || isRecording}
                    >
                        {`>>${languageButtonCodes[learnLanguage]}`}
                         {/* {'>>${learnLanguage}'} */}
                    {/* {'>>${languageButtonCodes[${learnLanguage}]}'} */}
                    {/* '>>EN'} */}
                    </Button>
                </Tooltip>
                <Tooltip title={nativeLanguage === "Chinese" ? "解释" : nativeLanguage === "Vietnamese" ? "Giải thích" : "Explain"}>
                    <Button
                        style={{ marginLeft: -4 }}
                        color="primary"
                        onClick={() => handleSendMessage("2", "ExampleInput")}
                        disabled={message.trim() === "" || thinking || isRecording}
                    >
                        {'Explain'}
                    </Button>
                </Tooltip>
                <Tooltip title={nativeLanguage === "Chinese" ? "造一个句子" : nativeLanguage === "Vietnamese" ? "Làm câu văn" : "Make sentences"}>
                    <Button
                        style={{ marginLeft: -4 }}
                        color="primary"
                        onClick={() => handleSendMessage("2", "MakeSentenceInput")}
                        disabled={message.trim() === "" || thinking || isRecording}
                    >
                        {'Make'}
                        {/* {'word?'} */}
                    </Button>
                </Tooltip>
                <Tooltip title={nativeLanguage === "Chinese" ? "检查语法和单词" : nativeLanguage === "Vietnamese" ? "Kiểm tra ngữ pháp và từ ngữ" : "Check grammar and words"}>
                    <Button
                        style={{ marginLeft: -6 }}
                        color="primary"
                        onClick={() => handleSendMessage("2", "CheckInput")}
                        disabled={message.trim() === "" || thinking || isRecording}
                    >
                        {'Check'}
                    </Button>
                </Tooltip>
                <Tooltip title={nativeLanguage === "Chinese" ? "有用的句子" : nativeLanguage === "Vietnamese" ? "Câu hữu ích" : "Useful Sentences"}>
                    <Button
                        style={{ marginLeft: -6 }}
                        color="primary"
                        onClick={() => handleSendMessage("5", "UsefulSentences")}
                        disabled={thinking || isRecording}
                    >
                        {'Book'}
                    </Button>
                </Tooltip>
            </Box>
        </>
    );
}

export const ChatFooter = ({ nativeLanguage }) => {
    const [expanded, setExpanded] = useState({
        userManual: false,
        usageRecommendations: false,
    });

    const toggleExpanded = (section) => {
        setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [section]: !prevExpanded[section],
        }));
    };

    return (
        <>
            <div className="bob">
                <div className="botchog">
                    <img src={LOGO} alt="" />
                </div>
                <Typography variant="h6" >
                    <div className="sungit">
                        一起说
                    </div>
                </Typography>
            </div>
            <br />
            <div >
                <Typography align="center" >
                    chat with AI to learn language, fast and fun.
                    <br />
                    17talk，用AI边聊边学，快速又快乐
                </Typography>
            </div>
            <br />
            <br />
            {nativeLanguage === "Chinese" ? (
                <>
                    <Typography align="left" variant="h6">
                    功能说明
                        <Tooltip title={expanded.userManual ? '少读书' : '阅读更多'}>
                    <Button onClick={() => toggleExpanded("userManual")}>
                        {expanded.userManual ? '▲' : '▼'}
                    </Button>
                        </Tooltip>
                    </Typography>
                    <div>
                    {expanded.userManual ? (
                    <>
                    AI回复消息后面中的按钮，依次为配音，复制和翻译<br/>
                    尚未配音的消息，点击耳朵按钮可以获得配音<br/>
                    已有配音的消息，可以播放、暂停和调整语速<br/>
                    点击“复制”按钮，可以快速复制消息到文字输入框<br/>
                    点击“翻译”按钮，可以快速得到整个消息的翻译<br/>
                    输入框上面的按钮：<br/>
                    左一用于设置是否自动配音。如果文字过长或网络不好，则配音会失效<br/>
                    网络不好的时候，可以关闭自动配音，只手动播放重点语句<br/>
                    中间两个选择为：所学语言的水平等级和可选话题<br/>
                    右一为麦克风（最多录12秒），停止录音，则AI自动把语音转为文字<br/>
                    输入框右边是发送按钮，用于发送消息给AI<br/>
                    在输入框输入文字后敲击回车键，也可以发送消息给AI<br/>
                    发送25秒后仍未得到回复，则需要重新发送<br/>
                    输入框下面的按钮，是针对文字输入框中的文字，提供翻译或检查等学习辅助<br/>
                    自己发送的消息，也可以复制到输入框里，点击CHECK来检查一下，得到标准的表达和配音<br/>
                    点击EXPLAIN，可以分解复杂句子，便于理解<br/>
                    点击BOOK按钮，可以看到围绕所选话题的常用句<br/>
                    网络不好的时候，页面可能会卡在奇怪的报错上。可以手动刷新页面来修复<br/>
                </>
                    ) : null}
                    </div>

                    <br />

                    <Typography align="left" variant="h6">
                    使用方法建议
                    <Tooltip
                    title={expanded.usageRecommendations ?  '少读书' : '阅读更多'}>
                    <Button onClick={() => toggleExpanded("usageRecommendations")}>
                        {expanded.usageRecommendations ? '▲' : '▼'}
                    </Button>
                    </Tooltip>
                    </Typography>
                    <div>
                    {expanded.usageRecommendations ? (
                  <>
                  先点击BOOK按钮，熟悉一下17talk为该话题准备的常用句，尽量应用在聊天中。<br/>
                  请选好等级和话题，然后告诉AI你的名字，开始聊天。<br/>
                  如果想模拟实际场景，可以使用Role Play模式，参考建议的Prompt。<br/>
                  为了更好的学习效果，请尽量使用完整的句子，而不是简单蹦词。<br/>
                  听着配音来读消息，既加深理解又提高发音，学习效率更高。<br/>
                  看不懂的句子，可以复制到输入框，然后用学习辅助工具来加深理解。<br/>
                  不确定语法和发音是否正确的句子，可以检查(CHECK)一下。<br/>
                  不必句句都检查，只要AI能听懂就好。毕竟进度快才会学得带劲。<br/>
                  检查后得到的标准表达，可复制到输入框再发给AI，以继续对话。<br/>
                  完成某个话题学习任务的标准，是熟练掌握了至少10句相关的表达，不限于AI建议的常用句。<br/>
                  助教会帮助您达成这个学习目标。遇到金句，请随时发到学习群里。<br/>
                  最后整理好的金句，手抄到本子上，拍照发到学习群里。<br/>
                  17talk会尽心辅佐您学习英语，请向您的亲朋好友多多推荐。谢谢啦！
              </>
                     ) : null}
                    </div>
              
                </>
            ) : nativeLanguage === "Vietnamese" ? (
                <>
                    <Typography align="left" variant="h6">
                    Hướng dẫn sử dụng
                        <Tooltip title={expanded.userManual ? 'Đọc ít hơn' : 'Đọc thêm'}>
                    <Button onClick={() => toggleExpanded("userManual")}>
                        {expanded.userManual ? '▲' : '▼'}
                    </Button>
                        </Tooltip>
                    </Typography>
                    <div>
                    {expanded.userManual ? (
                   <>
                   Các nút bên cạnh tin nhắn của AI bao gồm: giọng đọc, sao chép và dịch.<br/>
                   Biểu tượng "tai" là để lấy giọng đọc.<br/>
                   Giọng đọc có chức năng phát, tạm dừng và điều chỉnh tốc độ.<br/>
                   Nút "Sao chép" sao chép tin nhắn vào hộp nhập văn bản.<br/>
                   Nút "Dịch" cung cấp bản dịch của tin nhắn.<br/>
                   Các nút ở phía trên hộp nhập văn bản:<br/>
                   Nút bên trái nhất được sử dụng để cài đặt việc tự động tạo giọng đọc. Nếu văn bản quá dài hoặc mạng kém, quá trình tạo giọng đọc có thể thất bại.<br/>
                   Trong trường hợp mạng kém, bạn có thể tắt chế độ tự động tạo giọng đọc và phát lại câu quan trọng bằng cách thủ công.<br/>
                   Hai lựa chọn ở giữa là về trình độ sử dụng ngôn ngữ và các chủ đề tùy chọn.<br/>
                   Nút bên phải nhất dành cho microphone (tối đa 12 giây ghi âm). Dừng ghi âm và AI sẽ tự động chuyển đổi lời nói thành văn bản.<br/>
                   Ở bên phải của hộp nhập văn bản là nút gửi, được sử dụng để gửi tin nhắn đến AI.<br/>
                   Sau khi nhập văn bản vào hộp nhập, việc nhấn phím Enter cũng có thể gửi tin nhắn đến AI.<br/>
                   Nếu không có phản hồi sau 25 giây, bạn có thể cần gửi lại tin nhắn.<br/>
                   Phía dưới hộp nhập văn bản, có các nút dịch và kiểm tra lỗi, cùng với các tính năng hỗ trợ học tập thường được sử dụng khác.<br/>
                   Bạn có thể cung cấp sự hỗ trợ dịch hoặc kiểm tra cho văn bản trong hộp nhập văn bản.<br/>
                   Bạn cũng có thể sao chép các tin nhắn của bạn vào hộp nhập văn bản và nhấp vào "KIỂM TRA" để nhận các biểu đạt chuẩn và giọng đọc.<br/>
                   Nhấp vào "GIẢI THÍCH" cho phép bạn phân tích cú phức để dễ hiểu hơn.<br/>
                   Nhấp vào nút "SÁCH" cho phép bạn xem các câu thông thường liên quan đến chủ đề được chọn.<br/>
                   Trong trường hợp mạng kém, trang web có thể bị treo và hiển thị lỗi lạ. Bạn có thể làm mới trang web thủ công để khắc phục.
                    </>
                    ) : null}
                    </div>

                    <br />

                    <Typography align="left" variant="h6">
                    Gợi Ý Sử Dụng
                    <Tooltip
                    title={expanded.usageRecommendations ? 'Đọc ít hơn' : 'Đọc thêm'}>
                    <Button onClick={() => toggleExpanded("usageRecommendations")}>
                        {expanded.usageRecommendations ? '▲' : '▼'}
                    </Button>
                    </Tooltip>
                    </Typography>
                    <div>
                    {expanded.usageRecommendations ? (
                  <>
                  Bắt đầu bằng cách nhấn nút "SÁCH" và làm quen với những câu thường gặp được chuẩn bị sẵn bởi 17talk cho chủ đề đã chọn. Cố gắng áp dụng chúng trong cuộc trò chuyện của bạn càng nhiều càng tốt.<br/>
                  Xin vui lòng chọn trình độ của bạn và chủ đề, sau đó nói tên bạn cho AI để bắt đầu cuộc trò chuyện.<br/>
                  Nếu bạn muốn mô phỏng các tình huống thực tế, bạn có thể sử dụng chế độ Role Play và tham khảo các gợi ý được đề xuất.<br/>
                  Để có kết quả học tốt hơn, xin vui lòng sử dụng câu hoàn chỉnh thay vì từ đơn giản.<br/>
                  Nghe giọng đọc cùng lúc đọc tin nhắn; điều này giúp bạn hiểu sâu hơn và cải thiện cách phát âm, nâng cao hiệu suất học tập.<br/>
                  Nếu bạn không hiểu một câu, bạn có thể sao chép nó vào ô nhập văn bản và sử dụng các công cụ hỗ trợ học tập để hỗ trợ hiểu.<br/>
                  Đối với các câu có ngữ pháp và cách phát âm không chắc chắn, bạn có thể sử dụng "KIỂM TRA".<br/>
                  Không cần kiểm tra mọi câu; miễn là AI có thể hiểu, thì cũng không sao. Cuối cùng, tiến bộ nhanh hơn là thú vị hơn.<br/>
                  Sau khi kiểm tra, bạn có thể sao chép biểu thức tiêu chuẩn vào ô nhập và gửi cho AI để tiếp tục cuộc trò chuyện.<br/>
                  Chuẩn mực để hoàn thành một nhiệm vụ học chủ đề là thành thạo ít nhất 10 biểu thức liên quan, không giới hạn trong những câu được đề xuất.<br/>
                  Trợ lý sẽ giúp bạn đạt được mục tiêu học này. Bất cứ khi nào bạn gặp câu chữ quan trọng, hãy chia sẻ nó trong nhóm lớp học.<br/>
                  Cuối cùng, viết tay các câu chữ quan trọng vào một cuốn sổ, chụp ảnh và chia sẻ trong nhóm lớp học.<br/>
                  17talk cam kết hỗ trợ bạn trong việc học tiếng Anh; xin vui lòng giới thiệu chúng tôi cho bạn bè và gia đình của bạn. Cảm ơn bạn!
                 </>
                     ) : null}
                    </div>
              
              
                </>
            ) : (
               
                <>
                    <Typography align="left" variant="h6">
                        User Manual
                        <Tooltip title={expanded.userManual ? 'Read less' : 'Read more'}>
                    <Button onClick={() => toggleExpanded("userManual")}>
                        {expanded.userManual ? '▲' : '▼'}
                    </Button>
                        </Tooltip>
                    </Typography>
                    <div>
                    {expanded.userManual ? (
                     <>
                     Buttons next to AI's message are: voiceover, copy, and translation.<br/>
                     "Ear" icon is to get voiceover.<br/>
                     Voiceover has play, pause, and adjust speed functionalities.<br/>
                     "Copy" button copies the message to the text input box.<br/>
                     "Translate" button provides translation of the message.<br/>
                     Buttons above the input box:<br/>
                     The leftmost button is used to set whether to auto-generate voice. If the text is too long or the network is poor, voice generation may fail.<br/>
                     In case of poor network conditions, you can disable auto-voice generation and manually play important sentences.<br/>
                     The two middle selections are for the proficiency level of the language to learn and optional topics.<br/>
                     The rightmost button is for the microphone (up to 12 seconds of recording). Stop recording, and the AI will automatically convert the speech to text.<br/>
                     To the right of the input box is the send button, used to send messages to AI.<br/>
                     After entering text in the input box, hitting the Enter key can also send messages to AI.<br/>
                     If there is no reply after 25 seconds, you may need to resend the message.<br/>
                     Below the input box, there are buttons for translation and checking errors, among other commonly used learning assistance features.<br/>
                     You can provide translation or checking assistance for the text in the input box.<br/>
                     You can also copy your own messages to the input box and click "CHECK" to get standard expressions and voiceovers.<br/>
                     Clicking "EXPLAIN" allows you to break down complex sentences for easier understanding.<br/>
                     Clicking the "BOOK" button allows you to see commonly used sentences related to the selected topic.<br/>
                     In case of poor network conditions, the page may get stuck with strange errors. You can manually refresh the page to fix it.
                     </>
                    ) : null}
                    </div>

                    <br />

                    <Typography align="left" variant="h6">
                        Usage Recommendations
                    <Tooltip
                    title={expanded.usageRecommendations ? 'Read less' : 'Read more'}>
                    <Button onClick={() => toggleExpanded("usageRecommendations")}>
                        {expanded.usageRecommendations ? '▲' : '▼'}
                    </Button>
                    </Tooltip>
                    </Typography>
                    <div>
                    {expanded.usageRecommendations ? (
                   <>
                   Start by clicking the "BOOK" button and familiarize yourself with common sentences prepared by 17talk for the selected topic. Try to apply them in your chat as much as possible.<br/>
                   Please select your proficiency level and topic, then tell AI your name to start the conversation.<br/>
                   If you want to simulate real-life scenarios, you can use the Role Play mode and refer to the suggested prompts.<br/>
                   For better learning results, please use complete sentences rather than simple words.<br/>
                   Listen to voiceovers while reading messages; this deepens your understanding and improves pronunciation, enhancing learning efficiency.<br/>
                   If you don't understand a sentence, you can copy it to the input box and use learning assistance tools to aid comprehension.<br/>
                   For sentences with uncertain grammar and pronunciation, you can use "CHECK".<br/>
                   It's not necessary to check every sentence; as long as AI can understand, it's fine. After all, faster progress is more enjoyable.<br/>
                   After checking, you can copy the standard expression to the input box and send it to AI to continue the conversation.<br/>
                   The standard for completing a topic learning task is to master at least 10 related expressions, not limited to the suggested sentences.<br/>
                   The assistant will help you achieve this learning goal. Whenever you come across a key sentence, feel free to share it in the classin group.<br/>
                   Finally, handwrite the key sentences in a notebook, take a photo, and share it in the classin group.<br/>
                   17talk is dedicated to assisting you in learning English; please recommend us to your friends and family. Thank you!
                     </>
                     ) : null}
                    </div>
              
                </>
            )
            }

        </>
    )
}

export const UserMessage = styled('div', { shouldForwardProp: (prop) => prop !== 'audio' })`
position: relative;
background-color: ${({ theme }) => theme.palette.primary.main};
color: ${({ theme }) => theme.palette.primary.contrastText};
padding: ${({ theme }) => theme.spacing(1, 2)};
padding-right: ${({ theme, audio }) => (audio ? theme.spacing(6) : theme.spacing(2))};
border-radius: 1rem;
border-top-right-radius: 0;
align-self: flex-end;
max-width: 80%;
word-wrap: break-word;
`;

export const AgentMessage = styled('div')`
position: relative;
background-color: ${({ theme }) => theme.palette.grey[300]};
color: ${({ theme }) => theme.palette.text.primary};
padding: ${({ theme }) => theme.spacing(1, 2)};
border-radius: 1rem;
border-top-left-radius: 0;
align-self: flex-end;
max-width: 80%;
word-wrap: break-word;
`;

export const MessageWrapper = styled('div')`
display: flex;
margin-bottom: ${({ theme }) => theme.spacing(1)};
justify-content: ${({ align }) => (align === 'user' ? 'flex-end' : 'flex-start')};
`;